const SHORT_WORD = /(^|[\s\u00A0«„“"([—–-])([А-Яа-яЁё]{1,3}) +(?=\S)/g

const SKIP_SELECTOR = "textarea, input, script, style, code, pre, [contenteditable='true']"

function tieShortWords(text: string): string {
  SHORT_WORD.lastIndex = 0
  return text.replace(SHORT_WORD, (_, lead: string, word: string) => `${lead}${word}\u00A0`)
}

function acceptText(node: Node): number {
  const parent = (node as Text).parentElement
  const value = node.nodeValue
  if (!parent || !value || !value.includes(" ") || !/[А-Яа-яЁё]/.test(value)) {
    return NodeFilter.FILTER_REJECT
  }
  if (parent.closest(SKIP_SELECTOR)) {
    return NodeFilter.FILTER_REJECT
  }
  return NodeFilter.FILTER_ACCEPT
}

function apply(root: ParentNode) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: acceptText })
  const nodes: Text[] = []
  let current = walker.nextNode()
  while (current) {
    nodes.push(current as Text)
    current = walker.nextNode()
  }
  for (const node of nodes) {
    const next = tieShortWords(node.nodeValue || "")
    if (next !== node.nodeValue) {
      node.nodeValue = next
    }
  }
}

/** Предлоги и слова до 3 букв не остаются в конце строки: переносятся со следующим словом. */
export function bindHangingWords(root: ParentNode) {
  let scheduled = false
  const schedule = () => {
    if (scheduled) return
    scheduled = true
    requestAnimationFrame(() => {
      scheduled = false
      apply(root)
    })
  }

  schedule()
  const observer = new MutationObserver(schedule)
  observer.observe(root, { subtree: true, childList: true, characterData: true })
  return () => observer.disconnect()
}
